import React, { useEffect, useState } from "react";
import NavigationBanner from "../../components/common/NavigationBanner";
import { useParams } from "react-router-dom";
import axiosInstance from "../../utils/axios";
import TopContent from "./ServiceContentComponents/TopContentService";
import MiddleContent from "./ServiceContentComponents/MiddleContentService";
import LastContent from "./ServiceContentComponents/LastContentService";
import ServiceDonationProcess from "./ServiceDonation/ServiceDonationProcess";
import BannerImage from "../../Assets/Images/Bannerimage.png";
import BreadcrumbBanner from "../common/BreadcrumbBanner";
import DonationProcess from "../user/Dontations/DonationProcess";

const Services = () => {
  const { id } = useParams();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axiosInstance
      .get(`/services/service-by-id/${id}`)
      .then((res) => setService(res.data))
      .catch((err) => {
        console.error("Failed to fetch service by ID:", err);
        setError("Failed to load service details.");
      })
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <NavigationBanner />
        <div className="w-full py-6 px-6 animate-pulse">
          <div className="space-y-6">
            <div className="flex flex-col lg:flex-row w-full justify-center gap-5 items-start">
              <div className="h-80 w-[70%] bg-gray-300 rounded"></div>
              <div className="w-[30%] h-[400px] bg-gray-300 rounded"></div>
            </div>
            <div className="w-[30%] h-16 bg-gray-300 rounded"></div>
            <div className="w-[40%] h-10 bg-gray-300 rounded"></div>
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="w-[70%] h-6 bg-gray-300 rounded"></div>
            ))}
            <div className="w-[70%] h-6 bg-gray-300 rounded"></div>
          </div>
        </div>
      </div>
    );
  }

  if (error) return <div className="text-red-600 text-center">{error}</div>;

  return (
    <>
      {/* <NavigationBanner title={"Service Details"} background={BannerImage} /> */}
      <BreadcrumbBanner background={BannerImage} title={service?.serviceName} />

      <div className="flex flex-col lg:flex-row w-full justify-center gap-6 md:px-[3.5rem] px-4 py-6">
        {/* Left Section (scrollable content) */}
        <div className="w-full lg:w-[65%] xl:w-[70%]">
          <TopContent service={service} />
          <MiddleContent service={service} />
          {/* <LastContent service={service} /> */}
        </div>

        {/* Right Section (sticky donation box) */}
        <div className="w-full lg:w-[35%] xl:w-[30%]">
          <div className="sticky top-40">
            <DonationProcess type="Service" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;
